import React, {useState, useEffect, useContext, useRef } from 'react';
import { IonModal, IonGrid, IonRow, IonCol, IonButton, IonSlides, IonSlide, IonContent, IonHeader, IonFooter, IonInput, IonText, IonLoading } from '@ionic/react';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import '../../../css/layout.css';
import { ViewAttachement_ExpenseImageModal } from './Modal_ViewAttachement_ExpenseImage';
import { ViewInvoiceModal } from './Modal_ViewInvoice';

import {v4 as uuid} from 'uuid';

export function ExpenseDetailsModal(props) {


    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    const [merchantPhoneNumber_mtnMomo, setMerchantPhoneNumber_mtnMomo ] = useState(authenticatedMerchent_context.mtnCompanyPhoneNumber);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [viewExpenseDetailData, setViewExpenseDetailData] = useState([]);

    let [merchantAccountID, setMerchantAccountID] = useState(null);

    let [expenseID, setExpenseID] = useState(null);
    let [expenseDescription, setExpenseDescription] = useState([]);
    let [totalAmount, setTotalAmount] = useState(null);
    let [paymentType, setPaymentType] = useState(null);
    let [imageAttachement, setImageAttachement] = useState(null);
    let [viewAttachementModal, setViewAttachemntModal] = useState(false);
    let [viewInvoice, setViewInvoice] = useState(false);
    let [transactionID, setTransactionID] = useState(null);

    let [viewTransactions, setViewTransactions] = useState([]);

    let [supplierName, setSupplierName] = useState(null);
    let [supplierPhoneNumber, setSupplierPhoneNumber] = useState(null);
    let [invoiceID, setInvoiceID] = useState(null);
    let [invoiceTotal, setInvoiceTotal] = useState(null);
    let [merchantInvoiceID, setMerchantInvoiceID] = useState(null);
    let [customerInvoiceID, setCustomerInvoiceID] = useState(null);


    let [displaySetButton_pay, setDisplaySetButton_pay] = useState('inline-block');
    let [displayResetButton_pay, setDisplayResetButton_pay] = useState('none');
    let [disableSetButton_pay, setDisableSetButton_pay] = useState(false);
    let [disableResetButton_pay, setDisableResetButton_pay] = useState(false);

    let [disablePayButton, setDisablePayButton] = useState(false);

    let [isloading, setLoading] = useState(false);

    let enterPayRef = useRef(0);
    let paymentTypeRef = useRef('MTN-MOMO');

    const parseArray = (raw) => {
        try {
          let v = raw;
          if (typeof v === "string") v = JSON.parse(v);
          while (typeof v === "string" && (/^\s*[\[{]/.test(v))) v = JSON.parse(v);
          return Array.isArray(v) ? v : [];
        } catch {
          console.warn("Bad itemID_list JSON:", raw);
          return [];
        }
      };

    let [attachment_ID, setAttachment_ID ] = useState(() => {

        let noImageFile = new File([''], '/var/www/web/Public/fileServer/merchants/image-not-available.jpg', {
            enctype: 'multipart/form-data',
            type: 'file',
            name: 'xImageFile',
            accept: "image/*",
          });

          return noImageFile;
        
    });


   //getOccupiedRoomDetailData(instant_checkInRoomID) {
    useEffect(() => {

        //alert('In Occupied Detailed Data');
        //alert(props.openModal);

        if(props.openModal == true)
        {

            /*
            let formData = new FormData();
            formData.append('Tracker', '74002A_De');
            formData.append('user', acctID);
            formData.append('xExpenseID', props.data.expenseID);
        
        
            const requestOptions = {
                enctype: 'multipart/form-data',
                method:'POST',
                credentials: 'include',
                files: formData,
                body: formData,
                contentType: false,
                processData: false,
            }
            */

            const requestOptions = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                body: JSON.stringify({
                    Tracker: '74002A_De',
                    user: acctID,
                    xExpenseID: props.data.expenseID,
                    sessionID: sessionID,
    
                }),
            }
        
            

            let routePath;
            if(authenticatedMerchent_context.authenticated == 'T1')
            {
                routePath = 'hotel_merchantAcct_argsjqApp'
            }
            if(authenticatedMerchent_context.authenticated == 'T2')
            {
                routePath = 'proService_merchantAcct_argsjqApp'
            }
            if(authenticatedMerchent_context.authenticated == 'T3')
            {
                routePath = 'retail_merchantAcct_argsjqApp'
            }
        
            
        fetch(baseURL+routePath, requestOptions)
            .then(res => res.text())
            .then(res => {
        
                let rows = res.toString().split('~~~');
                let cols;

                for (let rownum = 0; rownum < rows.length - 1; ++rownum)
                {
                    cols = rows[rownum].split('|');


                    setViewExpenseDetailData((prevViewExpenseDetailData) => {
                        return prevViewExpenseDetailData.concat({
                            expenseID: cols[0],
                            supplierName: cols[1],
                            supplierPhoneNumber: cols[2],
                            expenseDescription: cols[3],
                            dateLogged: new Date(cols[4]).toISOString().substr(0, 10),
                            unitAmount: parseFloat(cols[5]).toFixed(2),
                            quantity: cols[6],
                            totalAmount: parseFloat(cols[7]).toFixed(2),
                            paymentType: cols[8],
                            attachment: cols[9],
                            invoiceForm: cols[10],
                            invoiceID: cols[11],
                            invoiceTotal: cols[12],
                            customerInvoiceID: cols[13],
                            transactionID: cols[14],
                            totalInvoiceAmount: cols[15],
                            transactionStatus: cols[16],
                            momo_provider: cols[17],
                            momo_financial_transaction_id: cols[18],
                            momo_external_id: cols[19],
                            momo_amount: cols[20],
                            momo_party_id: cols[21],
                            momo_payer_message: cols[22],
                            momo_payee_note: cols[23],
                            momo_pay_status: cols[24],
                            payment_type: cols[25],
                            merchantAccountID: cols[26],
                            merchantInvoiceID: cols[27],

                        })

                    });

                    setExpenseID(cols[0]);
                    setSupplierName(cols[1]);
                    setSupplierPhoneNumber(cols[2]);

                    //const itemID_list = parseArray(cols[1]); // JSON array-of-objects in col 1

                    setExpenseDescription(parseArray(cols[3]));
                    setInvoiceID(cols[11]);
                    setInvoiceTotal(cols[12]);
                    setCustomerInvoiceID(cols[13]);

                    setMerchantAccountID(cols[26]);
                    setMerchantInvoiceID(cols[27]);


                }    


                let rows2 = cols[14].toString().split('_');


                for (let rownum = 0; rownum < rows2.length - 1; ++rownum) {
                    let cols2 = rows2[rownum].split('#');


                    setViewTransactions((prevViewTransactions) => {
                        return prevViewTransactions.concat({
                            transactionID: cols2[0],
                            amount: cols2[1],
                            momo_pay_status: cols2[2],
                            transactionStatus: cols2[3],
                            payment_type: cols2[4],

                        });
                    });
                }
            })
        }
    }, [props.openModal]);


    function submitPay(event)
    {

        setDisablePayButton(true);
        setLoading(true);


        if (paymentTypeRef.current.value == 'CASH')
        {
            prepareInvoice_thenConfirmPay_nonMember([event, paymentTypeRef.current.value]);

            return;
        }
        return new Promise((resolve, reject) => {


            const customerPayAmount = parseFloat(event[5]).toFixed(2);
            const payCurrency = 'GHS';
            //const payExternalId = '';
            const payPartyId = event[3].replace(/^0+/, '');
            const payPayerMessage = event[7] + " Momo Payment";
            const payPayeeNote = "Bluefin Hotel Invoice";

            const apiuser = "824b5de8-0af9-4757-939b-f50992a0427f";
            const apikey = "e288a3938db14c8c9dfe3543427a141e";
            const concatenatedString = `${apiuser}:${apikey}`;
            const base64EncodedString = window.btoa(concatenatedString);

            let xReferenceID = uuid();

            //alert("BEFORE PAY");
            //alert(merchantPhoneNumber.replace(/^0+/, ''));
            //alert(merchantPhoneNumber);

            fetch(baseURL+'mtnapi/collection/token/', {
                method: 'POST',                                                                                                                                                                                                                 
                credentials: 'include',
                //mode: 'no-cors',
                //body: '',
                //Request headers
                headers: {
                    'authorization': 'Basic '+ base64EncodedString,
                    //'cache-Control': 'no-cache',
                    //'content-_type': 'application/json',
                    'ocp-apim-subscription-key': 'c4f861935bb543cbba9f3762cf13fd9e',
                    'x-target-environment': 'mtnghana',
                    'x-reference-id': xReferenceID.toString(),
                    'x-internal-reference-id': xReferenceID.toString(),
                    'tracker': '74108_B_update_successful_retail_addition',
                    'user': acctID,
                    'x_company_id_public': merchantAccountID,
                    'x_merchant_mobilenumber': supplierPhoneNumber.replace(/^0+/, ''),
                    'x_ProjectID': "N/A",
                    'x_customer_mobilenumber': event[3],
                    'x_invoice_id': event[1],
                    'x_customer_invoice_id': event[2],
                    'x_immediate_destination': merchantAccountID,
                    'x_check_in_amount': parseFloat(event[5]).toFixed(2),
                    'session_id': sessionID,
                    'momo_url': 'collection/v1_0/requesttopay',
                    'confirm_payment': 'confirm_or_reject',
                    // 'request_to_pay': JSON.stringify({
                    //     "amount": customerPayAmount,
                    //     "currency": payCurrency,
                    //     "externalId": xReferenceID.toString(),
                    //     "payer": {
                    //         "partyIdType": "MSISDN",
                    //         "partyId": "233"+payPartyId
                    //     },
                    //     "payerMessage": payPayerMessage,
                    //     "payeeNote": payPayeeNote
                    // }),
                    'customer_pay_amount': customerPayAmount,
                    'pay_currency': payCurrency,
                    'external_id': xReferenceID.toString(),
                    'party_id_type': 'MSISDN',
                    'party_id': payPartyId,
                    'pay_payer_message': payPayerMessage,
                    'pay_payee_note': payPayeeNote,

                },

            })
            .then(res => res.json())
            .then(res => {


                prepareInvoice_thenConfirmPay_nonMember([event, paymentTypeRef.current.value, 'MTN', res.financialTransactionId, res.externalId, res.amount, 'GHS', res.payer.partyIdType, res.payer.partyId, res.payerMessage, res.payeeNote, res.status, acctID]);

            })
        })
    }

    function prepareInvoice_thenConfirmPay_nonMember(event)
    {
                

        if(event[0][8] == "partial_paid")
        {

            const requestOptions = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                body: JSON.stringify({
                    Tracker: '74108_B_expense',
                    user: acctID,
                    xCompanyID_public: merchantAccountID,
                    xCustMobileNumber: event[0][3],
                    xInvoiceID: event[0][1],
                    xCustomerInvoiceID: event[0][2],
                    xImmediateDestination: merchantAccountID,
                    xCheckInCashAmount: parseFloat(event[0][5]).toFixed(2),
                    sessionID: sessionID,
                    xPaymentType: event[1],
                    xUserStatus: "member",
                    xMomo_provider: event[2],
                    xMomo_financial_transaction_id: event[3],
                    xMomo_external_id: event[4],
                    xMomo_amount: event[5],
                    xMomo_currency: event[6],
                    xmomo_party_id_type: event[7],
                    xMomo_party_id: event[8],
                    xMomo_payer_message: event[9],
                    xMomo_payee_note: event[10],
                    xMomo_pay_status: event[11],
    
                }),
            }

            fetch(baseURL+'internal_merchantAcct_argsjqApp', requestOptions)
            .then(res => res.text())
            .then(data => {

                confirmPayment_non_member([data, event[0][1], event[0][2], event[0][3], event[0][4], event[0][6], event[1], event[2], event[3], event[4], event[5], event[6], event[7], event[8], event[9], event[10], event[11]]);

            })
            .catch(error => {
                console.error(error);
            })

        }
 
    }

    let intervalID;

    function confirmPayment_non_member(event)
    {
        // alert("in Confrim Payment - nonmember");
        // alert(event);
        // alert(event[6]);

        let transactionID = event[0];
        let customerInvoiceID = event[2]; //undefined
        let customerPhoneNumber = event[3];
        let tracker = event[4];


        /*const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: tracker,
                user: event[20],
                xCompanyID_public: merchantAccountID,
                xInvoiceID: event[18],
                xZInvoiceID: event[19],
                xCustomerInvoiceID: customerInvoiceID, //undefined
                xTransactionID: transactionID,
                xCustMobileNumber: customerPhoneNumber,
                xOrderID: event[17],
                sessionID: sessionID,
                xPaymentType: event[6],
                xUserStatus: "member",
                xMomo_provider: event[7],
                xMomo_financial_transaction_id: event[8],
                xMomo_external_id: event[9],
                xMomo_amount: event[10],
                xMomo_currency: event[11],
                xmomo_party_id_type: event[12],
                xMomo_party_id: event[13],
                xMomo_payer_message: event[14],
                xMomo_payee_note: event[15],
                xMomo_pay_status: event[16],
                

            }),
        }

        fetch(baseURL+'ghanaverified/', requestOptions)
        .then(res => res.text())
        .then(data => {

            //alert("before loading");
            //alert("INITIAL PAYMENT REQUEST SENT.  PENDING CUSTOMER APPROVAL.");
            //alert(data);

            // if(isloading == true)
            // {
            //     alert("Please approve MTN momo request");
            //     setTimeout(getMomoStatus(transactionID), 5000);

            */

            if(event[6] == "mm" || event[6] == "MTN-MOMO")
            {
                                    intervalID = setInterval(() => {                                
                                    
                                            const requestOptions = {
                                                method: 'POST',
                                                //credentials: 'include',
                                                headers: {
                                                    'Accept': 'text/html, application/json',
                                                    'content-type': 'application/json',
                                                    //'cookie': 'cookie',
                                                },
                                                body: JSON.stringify({
                                                    Tracker: '74605_B_retail_public_check_payStatus',
                                                    user: acctID,
                                                    xCompanyID_public: merchantAccountID,
                                                    xTransactionID: transactionID,
                                                    sessionID: sessionID,
                                                    
                                                }),
                                            }
                                    
                                            fetch(baseURL+'ghanaverified/', requestOptions)
                                            .then(res => res.text())
                                            .then(data => {
                                                                        
                                                let rows = data.toString().split('~~~');
                                                //clearInterval(intervalID);

                                                
                                                for (let rownum = 0; rownum < rows.length - 1; ++rownum)
                                                {
                                                    let cols = rows[rownum].split('|');
                                    
                                                    if(cols[1] == "C" && cols[2] == "SUCCESSFUL")
                                                    {

                                                        //alert('PAYMENT SUCESSFUL.  YOU SHOULD RECIEVE INVOICE VIA TEXT.  YOUR RETAIL INVOICE ID IS '+cols[0]);
                                                        alert('PAYMENT SUCESSFUL.  YOUR RETAIL INVOICE ID IS '+cols[0]);

                                                        clearInterval(intervalID);

                                                        setLoading(false);

                                                        //authMerchant_objects.changeAuthenticated(authenticated);

                                                        //merchantLoginModal(false);
                                                        //history.push('/home');
                                                        window.location.href = '/';

                                                       // props.closeModal([cols[2], event[17], event[21], event[20]]);

                                                    }
                                                    else if(cols[2] == "NO_RESPONSE")
                                                    {

                                                        alert('PAYMENT UNSUCESSFUL. '+cols[2]+'.  PLEASE TRY AGAIN');

                                                        clearInterval(intervalID);
                                                        setLoading(false);
                                                        //authMerchant_objects.changeAuthenticated(authenticated);
                                                        //merchantLoginModal(false);
                                                        //props.closeModal([cols[2], event[17]]);
                                                        window.location.href = '/';


                                                    }
                                                    else
                                                    {
                                                        //alert("PLEASE APPROVE MOMO PAYMENT");

                                                        setLoading(true);
                                                        //clearInterval(intervalID);

                                                    }
                                    
                                                }
                                    
                                            })
            
                  }, 5000); //5 seconds
            }
            else
            {
                alert("INITIAL PAYMENT REQUEST SENT.  PENDING MERCHANT APPROVAL.");
                setLoading(false);
                window.location.href = '/';


            }

            // }
            // else
            // {
                //clearTimeout();
            // }

            //props.closeModal();
        //})
    }


    function setPayHandler()
    {
        setDisableSetButton_pay(true);
        setDisplaySetButton_pay('none');
        setDisableResetButton_pay(false);
        setDisplayResetButton_pay('inline-block');

    }

    function resetPayHandler()
    {
        setDisableResetButton_pay(true);
        setDisplayResetButton_pay('none');
        enterPayRef.current.value = '';
        setDisableSetButton_pay(false);
        setDisplayResetButton_pay('none');
        setDisplaySetButton_pay('inline-block');
    }

    function viewExpenseAttachmentHandler(event) {

        //alert('In viewExpenseInvoiceHandler');
        //alert(event);
        //alert(event[0]);
        //alert(event[3]);
        //alert(event[4]);
        //alert(event[5]);

        setTotalAmount(event[3]);
        setPaymentType(event[4]);
        setImageAttachement(event[5]);

        setViewAttachemntModal(event[0]);

        //setRoomID(event[1]);
        //setRoomSalePrice(event[2]);
    }

    function closeModalHandler() {

        setViewExpenseDetailData([]);
        props.closeModal(false);
    }

    return (
        <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
        <IonHeader style={{color: "black"}}>
            <IonGrid class='gridModalTopInfo'>
                    <IonRow>
                        <IonCol> Expense ID</IonCol>
                        <IonCol> Total Amount</IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol> {props.data.expenseID} </IonCol>
                        <IonCol> {props.data.totalAmount} </IonCol>
                    </IonRow>
            </IonGrid>
        </IonHeader>
        <IonContent className='grid_content'>
            {viewExpenseDetailData.map((detailData) =>   {
            return (
            <IonGrid>
                <IonRow >
                    <IonCol >Category</IonCol>
                    <IonCol >Value</IonCol>
                    <IonCol >Action</IonCol>
                </IonRow>
                <IonRow >
                    <IonCol >Supplier Name</IonCol>
                    <IonCol >{detailData.supplierName}</IonCol>
                    <IonCol >
                        <IonButton > - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol >Supplier Phone</IonCol>
                    <IonCol >{detailData.supplierPhoneNumber}</IonCol>
                    <IonCol >
                        <IonButton > - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol >Date Logged</IonCol>
                    <IonCol >{detailData.dateLogged}</IonCol>
                    <IonCol >
                        <IonButton > - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol >Expense Amount</IonCol>
                    <IonCol >{detailData.unitAmount}</IonCol>
                    <IonCol >
                        <IonButton > - </IonButton>
                    </IonCol>
                </IonRow>
                {/*<IonRow >
                    <IonCol >Quantity</IonCol>
                    <IonCol >{detailData.quantity}</IonCol>
                    <IonCol >
                        <IonButton > - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol >Description</IonCol>
                    <IonCol style={{fontSize: 'small'}}>{detailData.expenseDescription}</IonCol>
                    <IonCol >
                        <IonButton > - </IonButton>
                    </IonCol>
            </IonRow>*/}
                <IonRow className="outlinedRow">
                    <IonCol >DESCRIPTION</IonCol>
                </IonRow>
                <IonRow className="outlinedRow outlinedHeader">
                    <IonCol size='2'>ID</IonCol>
                    <IonCol size='4'>NAME</IonCol>
                    <IonCol size='3'>PRICE</IonCol>
                    <IonCol size='3'>QTY</IonCol>
                </IonRow>
                {expenseDescription.map((it) => {
                    return (
                        <IonRow className="outlinedRow">
                            <IonCol size='2'>
                                {it.id}
                            </IonCol>
                            <IonCol size='4'>
                                {it.name}
                            </IonCol>
                            <IonCol size='3'>
                                {it.price}                              
                            </IonCol>
                            <IonCol size='3'>
                                {it.quantity}                              
                            </IonCol>
                        </IonRow>
                    )}
                )}
                <IonRow >
                    <IonCol >Payment Type</IonCol>
                    <IonCol >{detailData.paymentType}</IonCol>
                    <IonCol >
                        <IonButton > - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol >Invoice</IonCol>
                    <IonCol >{"FILE"}</IonCol>
                    <IonCol >
                        <IonButton  onClick={() => setViewInvoice(true)}> View </IonButton>
                    </IonCol>

                   {viewInvoice == true && <ViewInvoiceModal openModal={ viewInvoice } closeModal={() => setViewInvoice(false)} data={{
                                        fileLocation: `/api/form/${detailData.invoiceForm}/${schema}`, 
                                        }}></ViewInvoiceModal>}
                </IonRow>
                <IonRow >
                    <IonCol >Attachment</IonCol>
                    <IonCol >{'Expense Attachment'}</IonCol>
                    <IonCol >
                        <ViewAttachement_ExpenseImageModal openModal={ viewAttachementModal } closeModal={() => setViewAttachemntModal(false)} data={{
                                                paymentType: detailData.paymentType, 
                                                totalAmount: detailData.totalAmount, 
                                                fileLocation: detailData.attachment, 
                                                }}></ViewAttachement_ExpenseImageModal>

                        <IonButton className='appListButton' onClick={() => viewExpenseAttachmentHandler([true, detailData.unitAmount, detailData.quantity, detailData.totalAmount, detailData.paymentType, detailData.attachment])}> View </IonButton>

                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' >Pay-To-Invoice</IonCol>
                    <IonCol size='6'>
                        <IonInput style={{display: displaySetButton_pay}} type='number' placeholder='Enter %' ref={enterPayRef}></IonInput>
                        <h4 style={{display: displayResetButton_pay}}>{enterPayRef.current.value+' GH'}</h4>
                    </IonCol>
                    <IonCol size='3'>
                        <IonButton style={{display: displaySetButton_pay}} disabled={disableSetButton_pay} onClick={() => setPayHandler()}>Set</IonButton>
                        <IonButton style={{display: displayResetButton_pay}} disabled={disableResetButton_pay} onClick={() => resetPayHandler()}>Reset</IonButton>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol>
                        <select name="payemntType" id='payemntType' ref={paymentTypeRef }>
                            <option value='CASH'>Cash</option>
                            <option value='MTN-MOMO' selected>Mobile Money</option>
                        </select>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol>
                        {(authenticatedMerchent_context.accessRights[0] == 'admin' || authenticatedMerchent_context.accessRights[0] == 'manager') && <IonButton id='gridResultColumnButton'  disabled={disablePayButton} onClick={() => submitPay([transactionID, merchantInvoiceID, customerInvoiceID, supplierPhoneNumber, '74605_B', enterPayRef.current.value, expenseID, supplierName, "partial_paid"])}> PAY</IonButton>}
                    </IonCol>
                </IonRow>
            </IonGrid>
                    )
                }
            )}

        {viewTransactions.map((detailData2) =>   {
            return (
                <IonGrid>
                    {detailData2.payment_type == 'CASH' && 
                    <IonRow >
                        <IonCol size='4'>
                            <IonText>{detailData2.payment_type}</IonText>
                        </IonCol>
                        <IonCol size='4'>
                            <IonText>{detailData2.amount}</IonText>
                        </IonCol>
                        <IonCol size='4' >
                            {((authenticatedMerchent_context.accessRights[0] == 'admin' || authenticatedMerchent_context.accessRights[0] == 'manager') && (detailData2.momo_pay_status == '' || detailData2.momo_pay_status == 'NO_RESPONSE' || detailData2.momo_pay_status == 'FAILED' || detailData2.momo_pay_status == 'N/A' || detailData2.momo_pay_status == 'SUCCESSFUL' || detailData2.momo_pay_status == 'CASH')) &&   <IonText >PAID</IonText>}
                            {((authenticatedMerchent_context.accessRights[0] == 'admin' || authenticatedMerchent_context.accessRights[0] == 'manager') && detailData2.momo_pay_status  == 'PENDING') &&   <IonButton id='gridResultColumnButton' disabled={true} > Pending</IonButton>}
                        </IonCol>
                    </IonRow>
                    }
                    {(detailData2.payment_type == 'mm' || detailData2.payment_type == 'MTN-MOMO') && 
                    <IonRow >
                        <IonCol size='4'>
                            <IonText>{detailData2.payment_type}</IonText>
                        </IonCol>
                        <IonCol size='4'>
                            <IonText>{detailData2.amount}</IonText>
                        </IonCol>
                        <IonCol size='4' >
                            {((authenticatedMerchent_context.accessRights[0] == 'admin' || authenticatedMerchent_context.accessRights[0] == 'manager') && (detailData2.momo_pay_status == '' || detailData2.momo_pay_status == 'NO_RESPONSE' || detailData2.momo_pay_status == 'FAILED' || detailData2.momo_pay_status == 'N/A' || detailData2.momo_pay_status == 'SUCCESSFUL' || detailData2.momo_pay_status == 'CASH')) &&   <IonText >PAID</IonText>}
                            {((authenticatedMerchent_context.accessRights[0] == 'admin' || authenticatedMerchent_context.accessRights[0] == 'manager') && detailData2.momo_pay_status  == 'PENDING') &&   <IonButton id='gridResultColumnButton' disabled={true} > FAILED</IonButton>}
                        </IonCol>
                    </IonRow>
                    }
                </IonGrid>
                    )}
            )}

                {isloading == true && <IonLoading
                        isOpen={isloading}
                        message={'Please wait...'}
                        duration={0} // Show until manually dismissed
                    />}

        </IonContent>
        <IonFooter className='grid_footer'>
                <IonGrid>
                    <IonRow>
                        <IonCol size="12">
                            <IonButton onClick={closeModalHandler}> Close </IonButton>
                        </IonCol>
                    </IonRow>
                </IonGrid>
        </IonFooter>
    </IonModal>) : null}
    </React.Fragment>
    )
}